import { render, staticRenderFns } from "./PersonalSummary.vue?vue&type=template&id=3c04aa91&scoped=true"
import script from "./PersonalSummary.vue?vue&type=script&lang=js"
export * from "./PersonalSummary.vue?vue&type=script&lang=js"
import style0 from "./PersonalSummary.vue?vue&type=style&index=0&id=3c04aa91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c04aa91",
  null
  
)

export default component.exports